import { get } from 'lodash-es';
import { type Features } from '@is24at/schemas/types';

export const features = (expose: any) => {
  const activeFeatures = get<Features>(expose, 'features', {});

  return Object.keys(activeFeatures)
    .map((featureName) =>
      featureName === 'REALTOR_BADGE'
        ? `REALTOR_BADGE_${activeFeatures.REALTOR_BADGE?.type}`
        : featureName,
    )
    .sort();
};
